import { useEffect, useState, useRef } from 'react';
import './CodePage.css';
import lottie from 'lottie-web'; 
import loadingBear from '../assets/loadingBear.json'; 

const CodePage = () => {
  const [error, setError] = useState('');
  const [codigo, setCodigo] = useState('');
  const [correo, setCorreo] = useState('');
  const [isLoading, setIsLoading] = useState(true); 
  const loadingBearRef = useRef(null); 
  const animInstanceRef = useRef(null); 

  useEffect(() => {
    const correoGuardado = sessionStorage.getItem('consultaCorreo');

    if (!correoGuardado || !correoGuardado.includes('@')) {
      setError('No se encontró un correo válido para la consulta.');
      setIsLoading(false);
      return;
    }

    setCorreo(correoGuardado);

if (!animInstanceRef.current) {
    animInstanceRef.current = lottie.loadAnimation({
      container: loadingBearRef.current,
      animationData: loadingBear,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });
  }
    const tipo = sessionStorage.getItem('tipoServicio') || 'disney';
    //fetch(`/api/redirigir?correo=${encodeURIComponent(correoGuardado)}&tipo=${tipo}`)

    fetch(`https://backendcodigosbearmax.onrender.com/api/redirigir?correo=${encodeURIComponent(correoGuardado)}&tipo=${tipo}`)

      .then(res => {
        if (!res.ok) throw new Error('Error al conectar con el backend');
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error('Respuesta inesperada del backend');
        }

        const [respuesta] = data;

        if (respuesta?.encontrado) {
          setCodigo(respuesta.codigoAcceso);
        } else {
          setError(respuesta?.mensajeCompleto || 'No se encontró el código. Si el problema persiste, contacta a soporte.');
        }

        setTimeout(() => {
          sessionStorage.removeItem('consultaCorreo');
          setIsLoading(false); 
          animInstanceRef.current?.destroy(); 
        }, 800);
      })
      .catch(err => {
        console.error('Error en fetch:', err);
        setError('Error al conectar con Google Apps Script. Contacta a  soporte.');
        setIsLoading(false);
        animInstanceRef.current?.destroy();
      });
  }, []);

  const handleRetry = () => {
    sessionStorage.removeItem('consultaCorreo');
    window.history.back();
  };

  return (
    <div className="code-page-container">
      <h1 className="code-title">Consulta enviada</h1>

      {error ? (
        <div>
          <p style={{ color: 'red' }}>{error}</p>
          <button onClick={handleRetry} className="get-new-code-btn">Intentar de nuevo 😒</button>
        </div>
      ) : (
        <div>
          <p>Correo consultado:</p>
          <pre className="code-output">{correo}</pre>
          

          {isLoading ? (
            <>
              <div className="loading-animation-inline" ref={loadingBearRef}></div> 
              <p>Buscando el código... 🐻</p>
              <p>Si recien enviaste el código espera un momento, lo estamos procesando </p>
            </>
          ) : (
            <div>
              <h2>Tu código es: </h2>
              <div className="code-output">{codigo}</div>

              <button className="get-new-code-btn" onClick={handleRetry}>
                ← Cerrar
              </button>
            </div>
          )}

        
        </div>
      )}
    </div>
  );
};

export default CodePage;
